import { render, staticRenderFns } from "./certificate_vid.vue?vue&type=template&id=31e05700&scoped=true&"
import script from "./certificate_vid.vue?vue&type=script&lang=js&"
export * from "./certificate_vid.vue?vue&type=script&lang=js&"
import style0 from "./certificate_vid.vue?vue&type=style&index=0&id=31e05700&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31e05700",
  null
  
)

export default component.exports